import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const FirstCorinthians: Scripture = {
  "version": VERSIONS.KJV,
  "book": BOOKS.FIRST_CORINTHIANS,
  "chapters": [
    {
      "chapter": "1",
      "verses": [
        {
          "verse": "1",
          "text": "Paul, called to be an apostle of Jesus Christ through the will of God, and Sosthenes our brother,"
        },
        {
          "verse": "2",
          "text": "Unto the church of God which is at Corinth, to them that are sanctified in Christ Jesus, called to be saints, with all that in every place call upon the name of Jesus Christ our Lord, both theirs and ours:"
        },
        {
          "verse": "3",
          "text": "Grace be unto you, and peace, from God our Father, and from the Lord Jesus Christ."
        },
        {
          "verse": "4",
          "text": "I thank my God always on your behalf, for the grace of God which is given you by Jesus Christ;"
        },
        {
          "verse": "5",
          "text": "That in every thing ye are enriched by him, in all utterance, and in all knowledge;"
        },
        {
          "verse": "6",
          "text": "Even as the testimony of Christ was confirmed in you:"
        },
        {
          "verse": "7",
          "text": "So that ye come behind in no gift; waiting for the coming of our Lord Jesus Christ:"
        },
        {
          "verse": "8",
          "text": "Who shall also confirm you unto the end, that ye may be blameless in the day of our Lord Jesus Christ."
        },
        {
          "verse": "9",
          "text": "God is faithful, by whom ye were called unto the fellowship of his Son Jesus Christ our Lord."
        },
        {
          "verse": "10",
          "text": "Now I beseech you, brethren, by the name of our Lord Jesus Christ, that ye all speak the same thing, and that there be no divisions among you; but that ye be perfectly joined together in the same mind and in the same judgment."
        },
        {
          "verse": "11",
          "text": "For it hath been declared unto me of you, my brethren, by them which are of the house of Chloe, that there are contentions among you."
        },
        {
          "verse": "12",
          "text": "Now this I say, that every one of you saith, I am of Paul; and I of Apollos; and I of Cephas; and I of Christ."
        },
        {
          "verse": "13",
          "text": "Is Christ divided? was Paul crucified for you? or were ye baptized in the name of Paul?"
        },
        {
          "verse": "14",
          "text": "I thank God that I baptized none of you, but Crispus and Gaius;"
        },
        {
          "verse": "15",
          "text": "Lest any should say that I had baptized in mine own name."
        },
        {
          "verse": "16",
          "text": "And I baptized also the household of Stephanas: besides, I know not whether I baptized any other."
        },
        {
          "verse": "17",
          "text": "For Christ sent me not to baptize, but to preach the gospel: not with wisdom of words, lest the cross of Christ should be made of none effect."
        },
        {
          "verse": "18",
          "text": "For the preaching of the cross is to them that perish foolishness; but unto us which are saved it is the power of God."
        },
        {
          "verse": "19",
          "text": "For it is written, I will destroy the wisdom of the wise, and will bring to nothing the understanding of the prudent."
        },
        {
          "verse": "20",
          "text": "Where is the wise? where is the scribe? where is the disputer of this world? hath not God made foolish the wisdom of this world?"
        },
        {
          "verse": "21",
          "text": "For after that in the wisdom of God the world by wisdom knew not God, it pleased God by the foolishness of preaching to save them that believe."
        },
        {
          "verse": "22",
          "text": "For the Jews require a sign, and the Greeks seek after wisdom:"
        },
        {
          "verse": "23",
          "text": "But we preach Christ crucified, unto the Jews a stumblingblock, and unto the Greeks foolishness;"
        },
        {
          "verse": "24",
          "text": "But unto them which are called, both Jews and Greeks, Christ the power of God, and the wisdom of God."
        },
        {
          "verse": "25",
          "text": "Because the foolishness of God is wiser than men; and the weakness of God is stronger than men."
        },
        {
          "verse": "26",
          "text": "For ye see your calling, brethren, how that not many wise men after the flesh, not many mighty, not many noble, are called:"
        },
        {
          "verse": "27",
          "text": "But God hath chosen the foolish things of the world to confound the wise; and God hath chosen the weak things of the world to confound the things which are mighty;"
        },
        {
          "verse": "28",
          "text": "And base things of the world, and things which are despised, hath God chosen, yea, and things which are not, to bring to nought things that are:"
        },
        {
          "verse": "29",
          "text": "That no flesh should glory in his presence."
        },
        {
          "verse": "30",
          "text": "But of him are ye in Christ Jesus, who of God is made unto us wisdom, and righteousness, and sanctification, and redemption:"
        },
        {
          "verse": "31",
          "text": "That, according as it is written, He that glorieth, let him glory in the Lord."
        }
      ]
    },
    {
      "chapter": "2",
      "verses": [
        {
          "verse": "1",
          "text": "And I, brethren, when I came to you, came not with excellency of speech or of wisdom, declaring unto you the testimony of God."
        },
        {
          "verse": "2",
          "text": "For I determined not to know any thing among you, save Jesus Christ, and him crucified."
        },
        {
          "verse": "3",
          "text": "And I was with you in weakness, and in fear, and in much trembling."
        },
        {
          "verse": "4",
          "text": "And my speech and my preaching was not with enticing words of man\u2019s wisdom, but in demonstration of the Spirit and of power:"
        },
        {
          "verse": "5",
          "text": "That your faith should not stand in the wisdom of men, but in the power of God."
        },
        {
          "verse": "6",
          "text": "Howbeit we speak wisdom among them that are perfect: yet not the wisdom of this world, nor of the princes of this world, that come to nought:"
        },
        {
          "verse": "7",
          "text": "But we speak the wisdom of God in a mystery, even the hidden wisdom, which God ordained before the world unto our glory:"
        },
        {
          "verse": "8",
          "text": "Which none of the princes of this world knew: for had they known it, they would not have crucified the Lord of glory."
        },
        {
          "verse": "9",
          "text": "But as it is written, Eye hath not seen, nor ear heard, neither have entered into the heart of man, the things which God hath prepared for them that love him."
        },
        {
          "verse": "10",
          "text": "But God hath revealed them unto us by his Spirit: for the Spirit searcheth all things, yea, the deep things of God."
        },
        {
          "verse": "11",
          "text": "For what man knoweth the things of a man, save the spirit of man which is in him? even so the things of God knoweth no man, but the Spirit of God."
        },
        {
          "verse": "12",
          "text": "Now we have received, not the spirit of the world, but the spirit which is of God; that we might know the things that are freely given to us of God."
        },
        {
          "verse": "13",
          "text": "Which things also we speak, not in the words which man\u2019s wisdom teacheth, but which the Holy Ghost teacheth; comparing spiritual things with spiritual."
        },
        {
          "verse": "14",
          "text": "But the natural man receiveth not the things of the Spirit of God: for they are foolishness unto him: neither can he know them, because they are spiritually discerned."
        },
        {
          "verse": "15",
          "text": "But he that is spiritual judgeth all things, yet he himself is judged of no man."
        },
        {
          "verse": "16",
          "text": "For who hath known the mind of the Lord, that he may instruct him? But we have the mind of Christ."
        }
      ]
    },
    {
      "chapter": "3",
      "verses": [
        {
          "verse": "1",
          "text": "And I, brethren, could not speak unto you as unto spiritual, but as unto carnal, even as unto babes in Christ."
        },
        {
          "verse": "2",
          "text": "I have fed you with milk, and not with meat: for hitherto ye were not able to bear it, neither yet now are ye able."
        },
        {
          "verse": "3",
          "text": "For ye are yet carnal: for whereas there is among you envying, and strife, and divisions, are ye not carnal, and walk as men?"
        },
        {
          "verse": "4",
          "text": "For while one saith, I am of Paul; and another, I am of Apollos; are ye not carnal?"
        },
        {
          "verse": "5",
          "text": "Who then is Paul, and who is Apollos, but ministers by whom ye believed, even as the Lord gave to every man?"
        },
        {
          "verse": "6",
          "text": "I have planted, Apollos watered; but God gave the increase."
        },
        {
          "verse": "7",
          "text": "So then neither is he that planteth any thing, neither he that watereth; but God that giveth the increase."
        },
        {
          "verse": "8",
          "text": "Now he that planteth and he that watereth are one: and every man shall receive his own reward according to his own labour."
        },
        {
          "verse": "9",
          "text": "For we are labourers together with God: ye are God\u2019s husbandry, ye are God\u2019s building."
        },
        {
          "verse": "10",
          "text": "According to the grace of God which is given unto me, as a wise masterbuilder, I have laid the foundation, and another buildeth thereon. But let every man take heed how he buildeth thereupon."
        },
        {
          "verse": "11",
          "text": "For other foundation can no man lay than that is laid, which is Jesus Christ."
        },
        {
          "verse": "12",
          "text": "Now if any man build upon this foundation gold, silver, precious stones, wood, hay, stubble;"
        },
        {
          "verse": "13",
          "text": "Every man\u2019s work shall be made manifest: for the day shall declare it, because it shall be revealed by fire; and the fire shall try every man\u2019s work of what sort it is."
        },
        {
          "verse": "14",
          "text": "If any man\u2019s work abide which he hath built thereupon, he shall receive a reward."
        },
        {
          "verse": "15",
          "text": "If any man\u2019s work shall be burned, he shall suffer loss: but he himself shall be saved; yet so as by fire."
        },
        {
          "verse": "16",
          "text": "Know ye not that ye are the temple of God, and that the Spirit of God dwelleth in you?"
        },
        {
          "verse": "17",
          "text": "If any man defile the temple of God, him shall God destroy; for the temple of God is holy, which temple ye are."
        },
        {
          "verse": "18",
          "text": "Let no man deceive himself. If any man among you seemeth to be wise in this world, let him become a fool, that he may be wise."
        },
        {
          "verse": "19",
          "text": "For the wisdom of this world is foolishness with God. For it is written, He taketh the wise in their own craftiness."
        },
        {
          "verse": "20",
          "text": "And again, The Lord knoweth the thoughts of the wise, that they are vain."
        },
        {
          "verse": "21",
          "text": "Therefore let no man glory in men. For all things are yours;"
        },
        {
          "verse": "22",
          "text": "Whether Paul, or Apollos, or Cephas, or the world, or life, or death, or things present, or things to come; all are yours;"
        },
        {
          "verse": "23",
          "text": "And ye are Christ\u2019s; and Christ is God\u2019s."
        }
      ]
    },
    {
      "chapter": "4",
      "verses": [
        {
          "verse": "1",
          "text": "Let a man so account of us, as of the ministers of Christ, and stewards of the mysteries of God."
        },
        {
          "verse": "2",
          "text": "Moreover it is required in stewards, that a man be found faithful."
        },
        {
          "verse": "3",
          "text": "But with me it is a very small thing that I should be judged of you, or of man\u2019s judgment: yea, I judge not mine own self."
        },
        {
          "verse": "4",
          "text": "For I know nothing by myself; yet am I not hereby justified: but he that judgeth me is the Lord."
        },
        {
          "verse": "5",
          "text": "Therefore judge nothing before the time, until the Lord come, who both will bring to light the hidden things of darkness, and will make manifest the counsels of the hearts: and then shall every man have praise of God."
        },
        {
          "verse": "6",
          "text": "And these things, brethren, I have in a figure transferred to myself and to Apollos for your sakes; that ye might learn in us not to think of men above that which is written, that no one of you be puffed up for one against another."
        },
        {
          "verse": "7",
          "text": "For who maketh thee to differ from another? and what hast thou that thou didst not receive? now if thou didst receive it, why dost thou glory, as if thou hadst not received it?"
        },
        {
          "verse": "8",
          "text": "Now ye are full, now ye are rich, ye have reigned as kings without us: and I would to God ye did reign, that we also might reign with you."
        },
        {
          "verse": "9",
          "text": "For I think that God hath set forth us the apostles last, as it were appointed to death: for we are made a spectacle unto the world, and to angels, and to men."
        },
        {
          "verse": "10",
          "text": "We are fools for Christ\u2019s sake, but ye are wise in Christ; we are weak, but ye are strong; ye are honourable, but we are despised."
        },
        {
          "verse": "11",
          "text": "Even unto this present hour we both hunger, and thirst, and are naked, and are buffeted, and have no certain dwellingplace;"
        },
        {
          "verse": "12",
          "text": "And labour, working with our own hands: being reviled, we bless; being persecuted, we suffer it:"
        },
        {
          "verse": "13",
          "text": "Being defamed, we intreat: we are made as the filth of the world, and are the offscouring of all things unto this day."
        },
        {
          "verse": "14",
          "text": "I write not these things to shame you, but as my beloved sons I warn you."
        },
        {
          "verse": "15",
          "text": "For though ye have ten thousand instructors in Christ, yet have ye not many fathers: for in Christ Jesus I have begotten you through the gospel."
        },
        {
          "verse": "16",
          "text": "Wherefore I beseech you, be ye followers of me."
        },
        {
          "verse": "17",
          "text": "For this cause have I sent unto you Timotheus, who is my beloved son, and faithful in the Lord, who shall bring you into remembrance of my ways which be in Christ, as I teach every where in every church."
        },
        {
          "verse": "18",
          "text": "Now some are puffed up, as though I would not come to you."
        },
        {
          "verse": "19",
          "text": "But I will come to you shortly, if the Lord will, and will know, not the speech of them which are puffed up, but the power."
        },
        {
          "verse": "20",
          "text": "For the kingdom of God is not in word, but in power."
        },
        {
          "verse": "21",
          "text": "What will ye? shall I come unto you with a rod, or in love, and in the spirit of meekness?"
        }
      ]
    },
    {
      "chapter": "5",
      "verses": [
        {
          "verse": "1",
          "text": "It is reported commonly that there is fornication among you, and such fornication as is not so much as named among the Gentiles, that one should have his father\u2019s wife."
        },
        {
          "verse": "2",
          "text": "And ye are puffed up, and have not rather mourned, that he that hath done this deed might be taken away from among you."
        },
        {
          "verse": "3",
          "text": "For I verily, as absent in body, but present in spirit, have judged already, as though I were present, concerning him that hath so done this deed,"
        },
        {
          "verse": "4",
          "text": "In the name of our Lord Jesus Christ, when ye are gathered together, and my spirit, with the power of our Lord Jesus Christ,"
        },
        {
          "verse": "5",
          "text": "To deliver such an one unto Satan for the destruction of the flesh, that the spirit may be saved in the day of the Lord Jesus."
        },
        {
          "verse": "6",
          "text": "Your glorying is not good. Know ye not that a little leaven leaveneth the whole lump?"
        },
        {
          "verse": "7",
          "text": "Purge out therefore the old leaven, that ye may be a new lump, as ye are unleavened. For even Christ our passover is sacrificed for us:"
        },
        {
          "verse": "8",
          "text": "Therefore let us keep the feast, not with old leaven, neither with the leaven of malice and wickedness; but with the unleavened bread of sincerity and truth."
        },
        {
          "verse": "9",
          "text": "I wrote unto you in an epistle not to company with fornicators:"
        },
        {
          "verse": "10",
          "text": "Yet not altogether with the fornicators of this world, or with the covetous, or extortioners, or with idolaters; for then must ye needs go out of the world."
        },
        {
          "verse": "11",
          "text": "But now I have written unto you not to keep company, if any man that is called a brother be a fornicator, or covetous, or an idolater, or a railer, or a drunkard, or an extortioner; with such an one no not to eat."
        },
        {
          "verse": "12",
          "text": "For what have I to do to judge them also that are without? do not ye judge them that are within?"
        },
        {
          "verse": "13",
          "text": "But them that are without God judgeth. Therefore put away from among yourselves that wicked person."
        }
      ]
    },
    {
      "chapter": "6",
      "verses": [
        {
          "verse": "1",
          "text": "Dare any of you, having a matter against another, go to law before the unjust, and not before the saints?"
        },
        {
          "verse": "2",
          "text": "Do ye not know that the saints shall judge the world? and if the world shall be judged by you, are ye unworthy to judge the smallest matters?"
        },
        {
          "verse": "3",
          "text": "Know ye not that we shall judge angels? how much more things that pertain to this life?"
        },
        {
          "verse": "4",
          "text": "If then ye have judgments of things pertaining to this life, set them to judge who are least esteemed in the church."
        },
        {
          "verse": "5",
          "text": "I speak to your shame. Is it so, that there is not a wise man among you? no, not one that shall be able to judge between his brethren?"
        },
        {
          "verse": "6",
          "text": "But brother goeth to law with brother, and that before the unbelievers."
        },
        {
          "verse": "7",
          "text": "Now therefore there is utterly a fault among you, because ye go to law one with another. Why do ye not rather take wrong? why do ye not rather suffer yourselves to be defrauded?"
        },
        {
          "verse": "8",
          "text": "Nay, ye do wrong, and defraud, and that your brethren."
        },
        {
          "verse": "9",
          "text": "Know ye not that the unrighteous shall not inherit the kingdom of God? Be not deceived: neither fornicators, nor idolaters, nor adulterers, nor effeminate, nor abusers of themselves with mankind,"
        },
        {
          "verse": "10",
          "text": "Nor thieves, nor covetous, nor drunkards, nor revilers, nor extortioners, shall inherit the kingdom of God."
        },
        {
          "verse": "11",
          "text": "And such were some of you: but ye are washed, but ye are sanctified, but ye are justified in the name of the Lord Jesus, and by the Spirit of our God."
        },
        {
          "verse": "12",
          "text": "All things are lawful unto me, but all things are not expedient: all things are lawful for me, but I will not be brought under the power of any."
        },
        {
          "verse": "13",
          "text": "Meats for the belly, and the belly for meats: but God shall destroy both it and them. Now the body is not for fornication, but for the Lord; and the Lord for the body."
        },
        {
          "verse": "14",
          "text": "And God hath both raised up the Lord, and will also raise up us by his own power."
        },
        {
          "verse": "15",
          "text": "Know ye not that your bodies are the members of Christ? shall I then take the members of Christ, and make them the members of an harlot? God forbid."
        },
        {
          "verse": "16",
          "text": "What? know ye not that he which is joined to an harlot is one body? for two, saith he, shall be one flesh."
        },
        {
          "verse": "17",
          "text": "But he that is joined unto the Lord is one spirit."
        },
        {
          "verse": "18",
          "text": "Flee fornication. Every sin that a man doeth is without the body; but he that committeth fornication sinneth against his own body."
        },
        {
          "verse": "19",
          "text": "What? know ye not that your body is the temple of the Holy Ghost which is in you, which ye have of God, and ye are not your own?"
        },
        {
          "verse": "20",
          "text": "For ye are bought with a price: therefore glorify God in your body, and in your spirit, which are God\u2019s."
        }
      ]
    },
    {
      "chapter": "7",
      "verses": [
        {
          "verse": "1",
          "text": "Now concerning the things whereof ye wrote unto me: It is good for a man not to touch a woman."
        },
        {
          "verse": "2",
          "text": "Nevertheless, to avoid fornication, let every man have his own wife, and let every woman have her own husband."
        },
        {
          "verse": "3",
          "text": "Let the husband render unto the wife due benevolence: and likewise also the wife unto the husband."
        },
        {
          "verse": "4",
          "text": "The wife hath not power of her own body, but the husband: and likewise also the husband hath not power of his own body, but the wife."
        },
        {
          "verse": "5",
          "text": "Defraud ye not one the other, except it be with consent for a time, that ye may give yourselves to fasting and prayer; and come together again, that Satan tempt you not for your incontinency."
        },
        {
          "verse": "6",
          "text": "But I speak this by permission, and not of commandment."
        },
        {
          "verse": "7",
          "text": "For I would that all men were even as I myself. But every man hath his proper gift of God, one after this manner, and another after that."
        },
        {
          "verse": "8",
          "text": "I say therefore to the unmarried and widows, It is good for them if they abide even as I."
        },
        {
          "verse": "9",
          "text": "But if they cannot contain, let them marry: for it is better to marry than to burn."
        },
        {
          "verse": "10",
          "text": "And unto the married I command, yet not I, but the Lord, Let not the wife depart from her husband:"
        },
        {
          "verse": "11",
          "text": "But and if she depart, let her remain unmarried, or be reconciled to her husband: and let not the husband put away his wife."
        },
        {
          "verse": "12",
          "text": "But to the rest speak I, not the Lord: If any brother hath a wife that believeth not, and she be pleased to dwell with him, let him not put her away."
        },
        {
          "verse": "13",
          "text": "And the woman which hath an husband that believeth not, and if he be pleased to dwell with her, let her not leave him."
        },
        {
          "verse": "14",
          "text": "For the unbelieving husband is sanctified by the wife, and the unbelieving wife is sanctified by the husband: else were your children unclean; but now are they holy."
        },
        {
          "verse": "15",
          "text": "But if the unbelieving depart, let him depart. A brother or a sister is not under bondage in such cases: but God hath called us to peace."
        },
        {
          "verse": "16",
          "text": "For what knowest thou, O wife, whether thou shalt save thy husband? or how knowest thou, O man, whether thou shalt save thy wife?"
        },
        {
          "verse": "17",
          "text": "But as God hath distributed to every man, as the Lord hath called every one, so let him walk. And so ordain I in all churches."
        },
        {
          "verse": "18",
          "text": "Is any man called being circumcised? let him not become uncircumcised. Is any called in uncircumcision? let him not be circumcised."
        },
        {
          "verse": "19",
          "text": "Circumcision is nothing, and uncircumcision is nothing, but the keeping of the commandments of God."
        },
        {
          "verse": "20",
          "text": "Let every man abide in the same calling wherein he was called."
        },
        {
          "verse": "21",
          "text": "Art thou called being a servant? care not for it: but if thou mayest be made free, use it rather."
        },
        {
          "verse": "22",
          "text": "For he that is called in the Lord, being a servant, is the Lord\u2019s freeman: likewise also he that is called, being free, is Christ\u2019s servant."
        },
        {
          "verse": "23",
          "text": "Ye are bought with a price; be not ye the servants of men."
        },
        {
          "verse": "24",
          "text": "Brethren, let every man, wherein he is called, therein abide with God."
        },
        {
          "verse": "25",
          "text": "Now concerning virgins I have no commandment of the Lord: yet I give my judgment, as one that hath obtained mercy of the Lord to be faithful."
        },
        {
          "verse": "26",
          "text": "I suppose therefore that this is good for the present distress, I say, that it is good for a man so to be."
        },
        {
          "verse": "27",
          "text": "Art thou bound unto a wife? seek not to be loosed. Art thou loosed from a wife? seek not a wife."
        },
        {
          "verse": "28",
          "text": "But and if thou marry, thou hast not sinned; and if a virgin marry, she hath not sinned. Nevertheless such shall have trouble in the flesh: but I spare you."
        },
        {
          "verse": "29",
          "text": "But this I say, brethren, the time is short: it remaineth, that both they that have wives be as though they had none;"
        },
        {
          "verse": "30",
          "text": "And they that weep, as though they wept not; and they that rejoice, as though they rejoiced not; and they that buy, as though they possessed not;"
        },
        {
          "verse": "31",
          "text": "And they that use this world, as not abusing it: for the fashion of this world passeth away."
        },
        {
          "verse": "32",
          "text": "But I would have you without carefulness. He that is unmarried careth for the things that belong to the Lord, how he may please the Lord:"
        },
        {
          "verse": "33",
          "text": "But he that is married careth for the things that are of the world, how he may please his wife."
        },
        {
          "verse": "34",
          "text": "There is difference also between a wife and a virgin. The unmarried woman careth for the things of the Lord, that she may be holy both in body and in spirit: but she that is married careth for the things of the world, how she may please her husband."
        },
        {
          "verse": "35",
          "text": "And this I speak for your own profit; not that I may cast a snare upon you, but for that which is comely, and that ye may attend upon the Lord without distraction."
        },
        {
          "verse": "36",
          "text": "But if any man think that he behaveth himself uncomely toward his virgin, if she pass the flower of her age, and need so require, let him do what he will, he sinneth not: let them marry."
        },
        {
          "verse": "37",
          "text": "Nevertheless he that standeth stedfast in his heart, having no necessity, but hath power over his own will, and hath so decreed in his heart that he will keep his virgin, doeth well."
        },
        {
          "verse": "38",
          "text": "So then he that giveth her in marriage doeth well; but he that giveth her not in marriage doeth better."
        },
        {
          "verse": "39",
          "text": "The wife is bound by the law as long as her husband liveth; but if her husband be dead, she is at liberty to be married to whom she will; only in the Lord."
        },
        {
          "verse": "40",
          "text": "But she is happier if she so abide, after my judgment: and I think also that I have the Spirit of God."
        }
      ]
    },
    {
      "chapter": "8",
      "verses": [
        {
          "verse": "1",
          "text": "Now as touching things offered unto idols, we know that we all have knowledge. Knowledge puffeth up, but charity edifieth."
        },
        {
          "verse": "2",
          "text": "And if any man think that he knoweth any thing, he knoweth nothing yet as he ought to know."
        },
        {
          "verse": "3",
          "text": "But if any man love God, the same is known of him."
        },
        {
          "verse": "4",
          "text": "As concerning therefore the eating of those things that are offered in sacrifice unto idols, we know that an idol is nothing in the world, and that there is none other God but one."
        },
        {
          "verse": "5",
          "text": "For though there be that are called gods, whether in heaven or in earth, (as there be gods many, and lords many,)"
        },
        {
          "verse": "6",
          "text": "But to us there is but one God, the Father, of whom are all things, and we in him; and one Lord Jesus Christ, by whom are all things, and we by him."
        },
        {
          "verse": "7",
          "text": "Howbeit there is not in every man that knowledge: for some with conscience of the idol unto this hour eat it as a thing offered unto an idol; and their conscience being weak is defiled."
        },
        {
          "verse": "8",
          "text": "But meat commendeth us not to God: for neither, if we eat, are we the better; neither, if we eat not, are we the worse."
        },
        {
          "verse": "9",
          "text": "But take heed lest by any means this liberty of yours become a stumblingblock to them that are weak."
        },
        {
          "verse": "10",
          "text": "For if any man see thee which hast knowledge sit at meat in the idol\u2019s temple, shall not the conscience of him which is weak be emboldened to eat those things which are offered to idols;"
        },
        {
          "verse": "11",
          "text": "And through thy knowledge shall the weak brother perish, for whom Christ died?"
        },
        {
          "verse": "12",
          "text": "But when ye sin so against the brethren, and wound their weak conscience, ye sin against Christ."
        },
        {
          "verse": "13",
          "text": "Wherefore, if meat make my brother to offend, I will eat no flesh while the world standeth, lest I make my brother to offend."
        }
      ]
    },
    {
      "chapter": "9",
      "verses": [
        {
          "verse": "1",
          "text": "Am I not an apostle? am I not free? have I not seen Jesus Christ our Lord? are not ye my work in the Lord?"
        },
        {
          "verse": "2",
          "text": "If I be not an apostle unto others, yet doubtless I am to you: for the seal of mine apostleship are ye in the Lord."
        },
        {
          "verse": "3",
          "text": "Mine answer to them that do examine me is this,"
        },
        { "verse": "4", "text": "Have we not power to eat and to drink?" },
        {
          "verse": "5",
          "text": "Have we not power to lead about a sister, a wife, as well as other apostles, and as the brethren of the Lord, and Cephas?"
        },
        {
          "verse": "6",
          "text": "Or I only and Barnabas, have not we power to forbear working?"
        },
        {
          "verse": "7",
          "text": "Who goeth a warfare any time at his own charges? who planteth a vineyard, and eateth not of the fruit thereof? or who feedeth a flock, and eateth not of the milk of the flock?"
        },
        {
          "verse": "8",
          "text": "Say I these things as a man? or saith not the law the same also?"
        },
        {
          "verse": "9",
          "text": "For it is written in the law of Moses, Thou shalt not muzzle the mouth of the ox that treadeth out the corn. Doth God take care for oxen?"
        },
        {
          "verse": "10",
          "text": "Or saith he it altogether for our sakes? For our sakes, no doubt, this is written: that he that ploweth should plow in hope; and that he that thresheth in hope should be partaker of his hope."
        },
        {
          "verse": "11",
          "text": "If we have sown unto you spiritual things, is it a great thing if we shall reap your carnal things?"
        },
        {
          "verse": "12",
          "text": "If others be partakers of this power over you, are not we rather? Nevertheless we have not used this power; but suffer all things, lest we should hinder the gospel of Christ."
        },
        {
          "verse": "13",
          "text": "Do ye not know that they which minister about holy things live of the things of the temple? and they which wait at the altar are partakers with the altar?"
        },
        {
          "verse": "14",
          "text": "Even so hath the Lord ordained that they which preach the gospel should live of the gospel."
        },
        {
          "verse": "15",
          "text": "But I have used none of these things: neither have I written these things, that it should be so done unto me: for it were better for me to die, than that any man should make my glorying void."
        },
        {
          "verse": "16",
          "text": "For though I preach the gospel, I have nothing to glory of: for necessity is laid upon me; yea, woe is unto me, if I preach not the gospel!"
        },
        {
          "verse": "17",
          "text": "For if I do this thing willingly, I have a reward: but if against my will, a dispensation of the gospel is committed unto me."
        },
        {
          "verse": "18",
          "text": "What is my reward then? Verily that, when I preach the gospel, I may make the gospel of Christ without charge, that I abuse not my power in the gospel."
        },
        {
          "verse": "19",
          "text": "For though I be free from all men, yet have I made myself servant unto all, that I might gain the more."
        },
        {
          "verse": "20",
          "text": "And unto the Jews I became as a Jew, that I might gain the Jews; to them that are under the law, as under the law, that I might gain them that are under the law;"
        },
        {
          "verse": "21",
          "text": "To them that are without law, as without law, (being not without law to God, but under the law to Christ,) that I might gain them that are without law."
        },
        {
          "verse": "22",
          "text": "To the weak became I as weak, that I might gain the weak: I am made all things to all men, that I might by all means save some."
        },
        {
          "verse": "23",
          "text": "And this I do for the gospel\u2019s sake, that I might be partaker thereof with you."
        },
        {
          "verse": "24",
          "text": "Know ye not that they which run in a race run all, but one receiveth the prize? So run, that ye may obtain."
        },
        {
          "verse": "25",
          "text": "And every man that striveth for the mastery is temperate in all things. Now they do it to obtain a corruptible crown; but we an incorruptible."
        },
        {
          "verse": "26",
          "text": "I therefore so run, not as uncertainly; so fight I, not as one that beateth the air:"
        },
        {
          "verse": "27",
          "text": "But I keep under my body, and bring it into subjection: lest that by any means, when I have preached to others, I myself should be a castaway."
        }
      ]
    },
    {
      "chapter": "10",
      "verses": [
        {
          "verse": "1",
          "text": "Moreover, brethren, I would not that ye should be ignorant, how that all our fathers were under the cloud, and all passed through the sea;"
        },
        {
          "verse": "2",
          "text": "And were all baptized unto Moses in the cloud and in the sea;"
        },
        { "verse": "3", "text": "And did all eat the same spiritual meat;" },
        {
          "verse": "4",
          "text": "And did all drink the same spiritual drink: for they drank of that spiritual Rock that followed them: and that Rock was Christ."
        },
        {
          "verse": "5",
          "text": "But with many of them God was not well pleased: for they were overthrown in the wilderness."
        },
        {
          "verse": "6",
          "text": "Now these things were our examples, to the intent we should not lust after evil things, as they also lusted."
        },
        {
          "verse": "7",
          "text": "Neither be ye idolaters, as were some of them; as it is written, The people sat down to eat and drink, and rose up to play."
        },
        {
          "verse": "8",
          "text": "Neither let us commit fornication, as some of them committed, and fell in one day three and twenty thousand."
        },
        {
          "verse": "9",
          "text": "Neither let us tempt Christ, as some of them also tempted, and were destroyed of serpents."
        },
        {
          "verse": "10",
          "text": "Neither murmur ye, as some of them also murmured, and were destroyed of the destroyer."
        },
        {
          "verse": "11",
          "text": "Now all these things happened unto them for ensamples: and they are written for our admonition, upon whom the ends of the world are come."
        },
        {
          "verse": "12",
          "text": "Wherefore let him that thinketh he standeth take heed lest he fall."
        },
        {
          "verse": "13",
          "text": "There hath no temptation taken you but such as is common to man: but God is faithful, who will not suffer you to be tempted above that ye are able; but will with the temptation also make a way to escape, that ye may be able to bear it."
        },
        {
          "verse": "14",
          "text": "Wherefore, my dearly beloved, flee from idolatry."
        },
        {
          "verse": "15",
          "text": "I speak as to wise men; judge ye what I say."
        },
        {
          "verse": "16",
          "text": "The cup of blessing which we bless, is it not the communion of the blood of Christ? The bread which we break, is it not the communion of the body of Christ?"
        },
        {
          "verse": "17",
          "text": "For we being many are one bread, and one body: for we are all partakers of that one bread."
        },
        {
          "verse": "18",
          "text": "Behold Israel after the flesh: are not they which eat of the sacrifices partakers of the altar?"
        },
        {
          "verse": "19",
          "text": "What say I then? that the idol is any thing, or that which is offered in sacrifice to idols is any thing?"
        },
        {
          "verse": "20",
          "text": "But I say, that the things which the Gentiles sacrifice, they sacrifice to devils, and not to God: and I would not that ye should have fellowship with devils."
        },
        {
          "verse": "21",
          "text": "Ye cannot drink the cup of the Lord, and the cup of devils: ye cannot be partakers of the Lord\u2019s table, and of the table of devils."
        },
        {
          "verse": "22",
          "text": "Do we provoke the Lord to jealousy? are we stronger than he?"
        },
        {
          "verse": "23",
          "text": "All things are lawful for me, but all things are not expedient: all things are lawful for me, but all things edify not."
        },
        {
          "verse": "24",
          "text": "Let no man seek his own, but every man another\u2019s wealth."
        },
        {
          "verse": "25",
          "text": "Whatsoever is sold in the shambles, that eat, asking no question for conscience sake:"
        },
        {
          "verse": "26",
          "text": "For the earth is the Lord\u2019s, and the fulness thereof."
        },
        {
          "verse": "27",
          "text": "If any of them that believe not bid you to a feast, and ye be disposed to go; whatsoever is set before you, eat, asking no question for conscience sake."
        },
        {
          "verse": "28",
          "text": "But if any man say unto you, This is offered in sacrifice unto idols, eat not for his sake that shewed it, and for conscience sake: for the earth is the Lord\u2019s, and the fulness thereof:"
        },
        {
          "verse": "29",
          "text": "Conscience, I say, not thine own, but of the other: for why is my liberty judged of another man\u2019s conscience?"
        },
        {
          "verse": "30",
          "text": "For if I by grace be a partaker, why am I evil spoken of for that for which I give thanks?"
        },
        {
          "verse": "31",
          "text": "Whether therefore ye eat, or drink, or whatsoever ye do, do all to the glory of God."
        },
        {
          "verse": "32",
          "text": "Give none offence, neither to the Jews, nor to the Gentiles, nor to the church of God:"
        },
        {
          "verse": "33",
          "text": "Even as I please all men in all things, not seeking mine own profit, but the profit of many, that they may be saved."
        }
      ]
    },
    {
      "chapter": "11",
      "verses": [
        {
          "verse": "1",
          "text": "Be ye followers of me, even as I also am of Christ."
        },
        {
          "verse": "2",
          "text": "Now I praise you, brethren, that ye remember me in all things, and keep the ordinances, as I delivered them to you."
        },
        {
          "verse": "3",
          "text": "But I would have you know, that the head of every man is Christ; and the head of the woman is the man; and the head of Christ is God."
        },
        {
          "verse": "4",
          "text": "Every man praying or prophesying, having his head covered, dishonoureth his head."
        },
        {
          "verse": "5",
          "text": "But every woman that prayeth or prophesieth with her head uncovered dishonoureth her head: for that is even all one as if she were shaven."
        },
        {
          "verse": "6",
          "text": "For if the woman be not covered, let her also be shorn: but if it be a shame for a woman to be shorn or shaven, let her be covered."
        },
        {
          "verse": "7",
          "text": "For a man indeed ought not to cover his head, forasmuch as he is the image and glory of God: but the woman is the glory of the man."
        },
        {
          "verse": "8",
          "text": "For the man is not of the woman; but the woman of the man."
        },
        {
          "verse": "9",
          "text": "Neither was the man created for the woman; but the woman for the man."
        },
        {
          "verse": "10",
          "text": "For this cause ought the woman to have power on her head because of the angels."
        },
        {
          "verse": "11",
          "text": "Nevertheless neither is the man without the woman, neither the woman without the man, in the Lord."
        },
        {
          "verse": "12",
          "text": "For as the woman is of the man, even so is the man also by the woman; but all things of God."
        },
        {
          "verse": "13",
          "text": "Judge in yourselves: is it comely that a woman pray unto God uncovered?"
        },
        {
          "verse": "14",
          "text": "Doth not even nature itself teach you, that, if a man have long hair, it is a shame unto him?"
        },
        {
          "verse": "15",
          "text": "But if a woman have long hair, it is a glory to her: for her hair is given her for a covering."
        },
        {
          "verse": "16",
          "text": "But if any man seem to be contentious, we have no such custom, neither the churches of God."
        },
        {
          "verse": "17",
          "text": "Now in this that I declare unto you I praise you not, that ye come together not for the better, but for the worse."
        },
        {
          "verse": "18",
          "text": "For first of all, when ye come together in the church, I hear that there be divisions among you; and I partly believe it."
        },
        {
          "verse": "19",
          "text": "For there must be also heresies among you, that they which are approved may be made manifest among you."
        },
        {
          "verse": "20",
          "text": "When ye come together therefore into one place, this is not to eat the Lord\u2019s supper."
        },
        {
          "verse": "21",
          "text": "For in eating every one taketh before other his own supper: and one is hungry, and another is drunken."
        },
        {
          "verse": "22",
          "text": "What? have ye not houses to eat and to drink in? or despise ye the church of God, and shame them that have not? What shall I say to you? shall I praise you in this? I praise you not."
        },
        {
          "verse": "23",
          "text": "For I have received of the Lord that which also I delivered unto you, That the Lord Jesus the same night in which he was betrayed took bread:"
        },
        {
          "verse": "24",
          "text": "And when he had given thanks, he brake it, and said, Take, eat: this is my body, which is broken for you: this do in remembrance of me."
        },
        {
          "verse": "25",
          "text": "After the same manner also he took the cup, when he had supped, saying, This cup is the new testament in my blood: this do ye, as oft as ye drink it, in remembrance of me."
        },
        {
          "verse": "26",
          "text": "For as often as ye eat this bread, and drink this cup, ye do shew the Lord\u2019s death till he come."
        },
        {
          "verse": "27",
          "text": "Wherefore whosoever shall eat this bread, and drink this cup of the Lord, unworthily, shall be guilty of the body and blood of the Lord."
        },
        {
          "verse": "28",
          "text": "But let a man examine himself, and so let him eat of that bread, and drink of that cup."
        },
        {
          "verse": "29",
          "text": "For he that eateth and drinketh unworthily, eateth and drinketh damnation to himself, not discerning the Lord\u2019s body."
        },
        {
          "verse": "30",
          "text": "For this cause many are weak and sickly among you, and many sleep."
        },
        {
          "verse": "31",
          "text": "For if we would judge ourselves, we should not be judged."
        },
        {
          "verse": "32",
          "text": "But when we are judged, we are chastened of the Lord, that we should not be condemned with the world."
        },
        {
          "verse": "33",
          "text": "Wherefore, my brethren, when ye come together to eat, tarry one for another."
        },
        {
          "verse": "34",
          "text": "And if any man hunger, let him eat at home; that ye come not together unto condemnation. And the rest will I set in order when I come."
        }
      ]
    },
    {
      "chapter": "12",
      "verses": [
        {
          "verse": "1",
          "text": "Now concerning spiritual gifts, brethren, I would not have you ignorant."
        },
        {
          "verse": "2",
          "text": "Ye know that ye were Gentiles, carried away unto these dumb idols, even as ye were led."
        },
        {
          "verse": "3",
          "text": "Wherefore I give you to understand, that no man speaking by the Spirit of God calleth Jesus accursed: and that no man can say that Jesus is the Lord, but by the Holy Ghost."
        },
        {
          "verse": "4",
          "text": "Now there are diversities of gifts, but the same Spirit."
        },
        {
          "verse": "5",
          "text": "And there are differences of administrations, but the same Lord."
        },
        {
          "verse": "6",
          "text": "And there are diversities of operations, but it is the same God which worketh all in all."
        },
        {
          "verse": "7",
          "text": "But the manifestation of the Spirit is given to every man to profit withal."
        },
        {
          "verse": "8",
          "text": "For to one is given by the Spirit the word of wisdom; to another the word of knowledge by the same Spirit;"
        },
        {
          "verse": "9",
          "text": "To another faith by the same Spirit; to another the gifts of healing by the same Spirit;"
        },
        {
          "verse": "10",
          "text": "To another the working of miracles; to another prophecy; to another discerning of spirits; to another divers kinds of tongues; to another the interpretation of tongues:"
        },
        {
          "verse": "11",
          "text": "But all these worketh that one and the selfsame Spirit, dividing to every man severally as he will."
        },
        {
          "verse": "12",
          "text": "For as the body is one, and hath many members, and all the members of that one body, being many, are one body: so also is Christ."
        },
        {
          "verse": "13",
          "text": "For by one Spirit are we all baptized into one body, whether we be Jews or Gentiles, whether we be bond or free; and have been all made to drink into one Spirit."
        },
        { "verse": "14", "text": "For the body is not one member, but many." },
        {
          "verse": "15",
          "text": "If the foot shall say, Because I am not the hand, I am not of the body; is it therefore not of the body?"
        },
        {
          "verse": "16",
          "text": "And if the ear shall say, Because I am not the eye, I am not of the body; is it therefore not of the body?"
        },
        {
          "verse": "17",
          "text": "If the whole body were an eye, where were the hearing? If the whole were hearing, where were the smelling?"
        },
        {
          "verse": "18",
          "text": "But now hath God set the members every one of them in the body, as it hath pleased him."
        },
        {
          "verse": "19",
          "text": "And if they were all one member, where were the body?"
        },
        {
          "verse": "20",
          "text": "But now are they many members, yet but one body."
        },
        {
          "verse": "21",
          "text": "And the eye cannot say unto the hand, I have no need of thee: nor again the head to the feet, I have no need of you."
        },
        {
          "verse": "22",
          "text": "Nay, much more those members of the body, which seem to be more feeble, are necessary:"
        },
        {
          "verse": "23",
          "text": "And those members of the body, which we think to be less honourable, upon these we bestow more abundant honour; and our uncomely parts have more abundant comeliness."
        },
        {
          "verse": "24",
          "text": "For our comely parts have no need: but God hath tempered the body together, having given more abundant honour to that part which lacked:"
        },
        {
          "verse": "25",
          "text": "That there should be no schism in the body; but that the members should have the same care one for another."
        },
        {
          "verse": "26",
          "text": "And whether one member suffer, all the members suffer with it; or one member be honoured, all the members rejoice with it."
        },
        {
          "verse": "27",
          "text": "Now ye are the body of Christ, and members in particular."
        },
        {
          "verse": "28",
          "text": "And God hath set some in the church, first apostles, secondarily prophets, thirdly teachers, after that miracles, then gifts of healings, helps, governments, diversities of tongues."
        },
        {
          "verse": "29",
          "text": "Are all apostles? are all prophets? are all teachers? are all workers of miracles?"
        },
        {
          "verse": "30",
          "text": "Have all the gifts of healing? do all speak with tongues? do all interpret?"
        },
        {
          "verse": "31",
          "text": "But covet earnestly the best gifts: and yet shew I unto you a more excellent way."
        }
      ]
    },
    {
      "chapter": "13",
      "verses": [
        {
          "verse": "1",
          "text": "Though I speak with the tongues of men and of angels, and have not charity, I am become as sounding brass, or a tinkling cymbal."
        },
        {
          "verse": "2",
          "text": "And though I have the gift of prophecy, and understand all mysteries, and all knowledge; and though I have all faith, so that I could remove mountains, and have not charity, I am nothing."
        },
        {
          "verse": "3",
          "text": "And though I bestow all my goods to feed the poor, and though I give my body to be burned, and have not charity, it profiteth me nothing."
        },
        {
          "verse": "4",
          "text": "Charity suffereth long, and is kind; charity envieth not; charity vaunteth not itself, is not puffed up,"
        },
        {
          "verse": "5",
          "text": "Doth not behave itself unseemly, seeketh not her own, is not easily provoked, thinketh no evil;"
        },
        {
          "verse": "6",
          "text": "Rejoiceth not in iniquity, but rejoiceth in the truth;"
        },
        {
          "verse": "7",
          "text": "Beareth all things, believeth all things, hopeth all things, endureth all things."
        },
        {
          "verse": "8",
          "text": "Charity never faileth: but whether there be prophecies, they shall fail; whether there be tongues, they shall cease; whether there be knowledge, it shall vanish away."
        },
        {
          "verse": "9",
          "text": "For we know in part, and we prophesy in part."
        },
        {
          "verse": "10",
          "text": "But when that which is perfect is come, then that which is in part shall be done away."
        },
        {
          "verse": "11",
          "text": "When I was a child, I spake as a child, I understood as a child, I thought as a child: but when I became a man, I put away childish things."
        },
        {
          "verse": "12",
          "text": "For now we see through a glass, darkly; but then face to face: now I know in part; but then shall I know even as also I am known."
        },
        {
          "verse": "13",
          "text": "And now abideth faith, hope, charity, these three; but the greatest of these is charity."
        }
      ]
    },
    {
      "chapter": "14",
      "verses": [
        {
          "verse": "1",
          "text": "Follow after charity, and desire spiritual gifts, but rather that ye may prophesy."
        },
        {
          "verse": "2",
          "text": "For he that speaketh in an unknown tongue speaketh not unto men, but unto God: for no man understandeth him; howbeit in the spirit he speaketh mysteries."
        },
        {
          "verse": "3",
          "text": "But he that prophesieth speaketh unto men to edification, and exhortation, and comfort."
        },
        {
          "verse": "4",
          "text": "He that speaketh in an unknown tongue edifieth himself; but he that prophesieth edifieth the church."
        },
        {
          "verse": "5",
          "text": "I would that ye all spake with tongues, but rather that ye prophesied: for greater is he that prophesieth than he that speaketh with tongues, except he interpret, that the church may receive edifying."
        },
        {
          "verse": "6",
          "text": "Now, brethren, if I come unto you speaking with tongues, what shall I profit you, except I shall speak to you either by revelation, or by knowledge, or by prophesying, or by doctrine?"
        },
        {
          "verse": "7",
          "text": "And even things without life giving sound, whether pipe or harp, except they give a distinction in the sounds, how shall it be known what is piped or harped?"
        },
        {
          "verse": "8",
          "text": "For if the trumpet give an uncertain sound, who shall prepare himself to the battle?"
        },
        {
          "verse": "9",
          "text": "So likewise ye, except ye utter by the tongue words easy to be understood, how shall it be known what is spoken? for ye shall speak into the air."
        },
        {
          "verse": "10",
          "text": "There are, it may be, so many kinds of voices in the world, and none of them is without signification."
        },
        {
          "verse": "11",
          "text": "Therefore if I know not the meaning of the voice, I shall be unto him that speaketh a barbarian, and he that speaketh shall be a barbarian unto me."
        },
        {
          "verse": "12",
          "text": "Even so ye, forasmuch as ye are zealous of spiritual gifts, seek that ye may excel to the edifying of the church."
        },
        {
          "verse": "13",
          "text": "Wherefore let him that speaketh in an unknown tongue pray that he may interpret."
        },
        {
          "verse": "14",
          "text": "For if I pray in an unknown tongue, my spirit prayeth, but my understanding is unfruitful."
        },
        {
          "verse": "15",
          "text": "What is it then? I will pray with the spirit, and I will pray with the understanding also: I will sing with the spirit, and I will sing with the understanding also."
        },
        {
          "verse": "16",
          "text": "Else when thou shalt bless with the spirit, how shall he that occupieth the room of the unlearned say Amen at thy giving of thanks, seeing he understandeth not what thou sayest?"
        },
        {
          "verse": "17",
          "text": "For thou verily givest thanks well, but the other is not edified."
        },
        {
          "verse": "18",
          "text": "I thank my God, I speak with tongues more than ye all:"
        },
        {
          "verse": "19",
          "text": "Yet in the church I had rather speak five words with my understanding, that by my voice I might teach others also, than ten thousand words in an unknown tongue."
        },
        {
          "verse": "20",
          "text": "Brethren, be not children in understanding: howbeit in malice be ye children, but in understanding be men."
        },
        {
          "verse": "21",
          "text": "In the law it is written, With men of other tongues and other lips will I speak unto this people; and yet for all that will they not hear me, saith the LORD."
        },
        {
          "verse": "22",
          "text": "Wherefore tongues are for a sign, not to them that believe, but to them that believe not: but prophesying serveth not for them that believe not, but for them which believe."
        },
        {
          "verse": "23",
          "text": "If therefore the whole church be come together into one place, and all speak with tongues, and there come in those that are unlearned, or unbelievers, will they not say that ye are mad?"
        },
        {
          "verse": "24",
          "text": "But if all prophesy, and there come in one that believeth not, or one unlearned, he is convinced of all, he is judged of all:"
        },
        {
          "verse": "25",
          "text": "And thus are the secrets of his heart made manifest; and so falling down on his face he will worship God, and report that God is in you of a truth."
        },
        {
          "verse": "26",
          "text": "How is it then, brethren? when ye come together, every one of you hath a psalm, hath a doctrine, hath a tongue, hath a revelation, hath an interpretation. Let all things be done unto edifying."
        },
        {
          "verse": "27",
          "text": "If any man speak in an unknown tongue, let it be by two, or at the most by three, and that by course; and let one interpret."
        },
        {
          "verse": "28",
          "text": "But if there be no interpreter, let him keep silence in the church; and let him speak to himself, and to God."
        },
        {
          "verse": "29",
          "text": "Let the prophets speak two or three, and let the other judge."
        },
        {
          "verse": "30",
          "text": "If any thing be revealed to another that sitteth by, let the first hold his peace."
        },
        {
          "verse": "31",
          "text": "For ye may all prophesy one by one, that all may learn, and all may be comforted."
        },
        {
          "verse": "32",
          "text": "And the spirits of the prophets are subject to the prophets."
        },
        {
          "verse": "33",
          "text": "For God is not the author of confusion, but of peace, as in all churches of the saints."
        },
        {
          "verse": "34",
          "text": "Let your women keep silence in the churches: for it is not permitted unto them to speak; but they are commanded to be under obedience, as also saith the law."
        },
        {
          "verse": "35",
          "text": "And if they will learn any thing, let them ask their husbands at home: for it is a shame for women to speak in the church."
        },
        {
          "verse": "36",
          "text": "What? came the word of God out from you? or came it unto you only?"
        },
        {
          "verse": "37",
          "text": "If any man think himself to be a prophet, or spiritual, let him acknowledge that the things that I write unto you are the commandments of the Lord."
        },
        {
          "verse": "38",
          "text": "But if any man be ignorant, let him be ignorant."
        },
        {
          "verse": "39",
          "text": "Wherefore, brethren, covet to prophesy, and forbid not to speak with tongues."
        },
        {
          "verse": "40",
          "text": "Let all things be done decently and in order."
        }
      ]
    },
    {
      "chapter": "15",
      "verses": [
        {
          "verse": "1",
          "text": "Moreover, brethren, I declare unto you the gospel which I preached unto you, which also ye have received, and wherein ye stand;"
        },
        {
          "verse": "2",
          "text": "By which also ye are saved, if ye keep in memory what I preached unto you, unless ye have believed in vain."
        },
        {
          "verse": "3",
          "text": "For I delivered unto you first of all that which I also received, how that Christ died for our sins according to the scriptures;"
        },
        {
          "verse": "4",
          "text": "And that he was buried, and that he rose again the third day according to the scriptures:"
        },
        {
          "verse": "5",
          "text": "And that he was seen of Cephas, then of the twelve:"
        },
        {
          "verse": "6",
          "text": "After that, he was seen of above five hundred brethren at once; of whom the greater part remain unto this present, but some are fallen asleep."
        },
        {
          "verse": "7",
          "text": "After that, he was seen of James; then of all the apostles."
        },
        {
          "verse": "8",
          "text": "And last of all he was seen of me also, as of one born out of due time."
        },
        {
          "verse": "9",
          "text": "For I am the least of the apostles, that am not meet to be called an apostle, because I persecuted the church of God."
        },
        {
          "verse": "10",
          "text": "But by the grace of God I am what I am: and his grace which was bestowed upon me was not in vain; but I laboured more abundantly than they all: yet not I, but the grace of God which was with me."
        },
        {
          "verse": "11",
          "text": "Therefore whether it were I or they, so we preach, and so ye believed."
        },
        {
          "verse": "12",
          "text": "Now if Christ be preached that he rose from the dead, how say some among you that there is no resurrection of the dead?"
        },
        {
          "verse": "13",
          "text": "But if there be no resurrection of the dead, then is Christ not risen:"
        },
        {
          "verse": "14",
          "text": "And if Christ be not risen, then is our preaching vain, and your faith is also vain."
        },
        {
          "verse": "15",
          "text": "Yea, and we are found false witnesses of God; because we have testified of God that he raised up Christ: whom he raised not up, if so be that the dead rise not."
        },
        {
          "verse": "16",
          "text": "For if the dead rise not, then is not Christ raised:"
        },
        {
          "verse": "17",
          "text": "And if Christ be not raised, your faith is vain; ye are yet in your sins."
        },
        {
          "verse": "18",
          "text": "Then they also which are fallen asleep in Christ are perished."
        },
        {
          "verse": "19",
          "text": "If in this life only we have hope in Christ, we are of all men most miserable."
        },
        {
          "verse": "20",
          "text": "But now is Christ risen from the dead, and become the firstfruits of them that slept."
        },
        {
          "verse": "21",
          "text": "For since by man came death, by man came also the resurrection of the dead."
        },
        {
          "verse": "22",
          "text": "For as in Adam all die, even so in Christ shall all be made alive."
        },
        {
          "verse": "23",
          "text": "But every man in his own order: Christ the firstfruits; afterward they that are Christ\u2019s at his coming."
        },
        {
          "verse": "24",
          "text": "Then cometh the end, when he shall have delivered up the kingdom to God, even the Father; when he shall have put down all rule and all authority and power."
        },
        {
          "verse": "25",
          "text": "For he must reign, till he hath put all enemies under his feet."
        },
        {
          "verse": "26",
          "text": "The last enemy that shall be destroyed is death."
        },
        {
          "verse": "27",
          "text": "For he hath put all things under his feet. But when he saith all things are put under him, it is manifest that he is excepted, which did put all things under him."
        },
        {
          "verse": "28",
          "text": "And when all things shall be subdued unto him, then shall the Son also himself be subject unto him that put all things under him, that God may be all in all."
        },
        {
          "verse": "29",
          "text": "Else what shall they do which are baptized for the dead, if the dead rise not at all? why are they then baptized for the dead?"
        },
        { "verse": "30", "text": "And why stand we in jeopardy every hour?" },
        {
          "verse": "31",
          "text": "I protest by your rejoicing which I have in Christ Jesus our LORD, I die daily."
        },
        {
          "verse": "32",
          "text": "If after the manner of men I have fought with beasts at Ephesus, what advantageth it me, if the dead rise not? let us eat and drink; for to morrow we die."
        },
        {
          "verse": "33",
          "text": "Be not deceived: evil communications corrupt good manners."
        },
        {
          "verse": "34",
          "text": "Awake to righteousness, and sin not; for some have not the knowledge of God: I speak this to your shame."
        },
        {
          "verse": "35",
          "text": "But some man will say, How are the dead raised up? and with what body do they come?"
        },
        {
          "verse": "36",
          "text": "Thou fool, that which thou sowest is not quickened, except it die:"
        },
        {
          "verse": "37",
          "text": "And that which thou sowest, thou sowest not that body that shall be, but bare grain, it may chance of wheat, or of some other grain:"
        },
        {
          "verse": "38",
          "text": "But God giveth it a body as it hath pleased him, and to every seed his own body."
        },
        {
          "verse": "39",
          "text": "All flesh is not the same flesh: but there is one kind of flesh of men, another flesh of beasts, another of fishes, and another of birds."
        },
        {
          "verse": "40",
          "text": "There are also celestial bodies, and bodies terrestrial: but the glory of the celestial is one, and the glory of the terrestrial is another."
        },
        {
          "verse": "41",
          "text": "There is one glory of the sun, and another glory of the moon, and another glory of the stars: for one star differeth from another star in glory."
        },
        {
          "verse": "42",
          "text": "So also is the resurrection of the dead. It is sown in corruption; it is raised in incorruption:"
        },
        {
          "verse": "43",
          "text": "It is sown in dishonour; it is raised in glory: it is sown in weakness; it is raised in power:"
        },
        {
          "verse": "44",
          "text": "It is sown a natural body; it is raised a spiritual body. There is a natural body, and there is a spiritual body."
        },
        {
          "verse": "45",
          "text": "And so it is written, The first man Adam was made a living soul; the last Adam was made a quickening spirit."
        },
        {
          "verse": "46",
          "text": "Howbeit that was not first which is spiritual, but that which is natural; and afterward that which is spiritual."
        },
        {
          "verse": "47",
          "text": "The first man is of the earth, earthy: the second man is the Lord from heaven."
        },
        {
          "verse": "48",
          "text": "As is the earthy, such are they also that are earthy: and as is the heavenly, such are they also that are heavenly."
        },
        {
          "verse": "49",
          "text": "And as we have borne the image of the earthy, we shall also bear the image of the heavenly."
        },
        {
          "verse": "50",
          "text": "Now this I say, brethren, that flesh and blood cannot inherit the kingdom of God; neither doth corruption inherit incorruption."
        },
        {
          "verse": "51",
          "text": "Behold, I shew you a mystery; We shall not all sleep, but we shall all be changed,"
        },
        {
          "verse": "52",
          "text": "In a moment, in the twinkling of an eye, at the last trump: for the trumpet shall sound, and the dead shall be raised incorruptible, and we shall be changed."
        },
        {
          "verse": "53",
          "text": "For this corruptible must put on incorruption, and this mortal must put on immortality."
        },
        {
          "verse": "54",
          "text": "So when this corruptible shall have put on incorruption, and this mortal shall have put on immortality, then shall be brought to pass the saying that is written, Death is swallowed up in victory."
        },
        {
          "verse": "55",
          "text": "O death, where is thy sting? O grave, where is thy victory?"
        },
        {
          "verse": "56",
          "text": "The sting of death is sin; and the strength of sin is the law."
        },
        {
          "verse": "57",
          "text": "But thanks be to God, which giveth us the victory through our Lord Jesus Christ."
        },
        {
          "verse": "58",
          "text": "Therefore, my beloved brethren, be ye stedfast, unmoveable, always abounding in the work of the Lord, forasmuch as ye know that your labour is not in vain in the Lord."
        }
      ]
    },
    {
      "chapter": "16",
      "verses": [
        {
          "verse": "1",
          "text": "Now concerning the collection for the saints, as I have given order to the churches of Galatia, even so do ye."
        },
        {
          "verse": "2",
          "text": "Upon the first day of the week let every one of you lay by him in store, as God hath prospered him, that there be no gatherings when I come."
        },
        {
          "verse": "3",
          "text": "And when I come, whomsoever ye shall approve by your letters, them will I send to bring your liberality unto Jerusalem."
        },
        {
          "verse": "4",
          "text": "And if it be meet that I go also, they shall go with me."
        },
        {
          "verse": "5",
          "text": "Now I will come unto you, when I shall pass through Macedonia: for I do pass through Macedonia."
        },
        {
          "verse": "6",
          "text": "And it may be that I will abide, yea, and winter with you, that ye may bring me on my journey whithersoever I go."
        },
        {
          "verse": "7",
          "text": "For I will not see you now by the way; but I trust to tarry a while with you, if the Lord permit."
        },
        {
          "verse": "8",
          "text": "But I will tarry at Ephesus until Pentecost."
        },
        {
          "verse": "9",
          "text": "For a great door and effectual is opened unto me, and there are many adversaries."
        },
        {
          "verse": "10",
          "text": "Now if Timotheus come, see that he may be with you without fear: for he worketh the work of the Lord, as I also do."
        },
        {
          "verse": "11",
          "text": "Let no man therefore despise him: but conduct him forth in peace, that he may come unto me: for I look for him with the brethren."
        },
        {
          "verse": "12",
          "text": "As touching our brother Apollos, I greatly desired him to come unto you with the brethren: but his will was not at all to come at this time; but he will come when he shall have convenient time."
        },
        {
          "verse": "13",
          "text": "Watch ye, stand fast in the faith, quit you like men, be strong."
        },
        { "verse": "14", "text": "Let all your things be done with charity." },
        {
          "verse": "15",
          "text": "I beseech you, brethren, (ye know the house of Stephanas, that it is the firstfruits of Achaia, and that they have addicted themselves to the ministry of the saints,)"
        },
        {
          "verse": "16",
          "text": "That ye submit yourselves unto such, and to every one that helpeth with us, and laboureth."
        },
        {
          "verse": "17",
          "text": "I am glad of the coming of Stephanas and Fortunatus and Achaicus: for that which was lacking on your part they have supplied."
        },
        {
          "verse": "18",
          "text": "For they have refreshed my spirit and yours: therefore acknowledge ye them that are such."
        },
        {
          "verse": "19",
          "text": "The churches of Asia salute you. Aquila and Priscilla salute you much in the Lord, with the church that is in their house."
        },
        {
          "verse": "20",
          "text": "All the brethren greet you. Greet ye one another with an holy kiss."
        },
        {
          "verse": "21",
          "text": "The salutation of me Paul with mine own hand."
        },
        {
          "verse": "22",
          "text": "If any man love not the Lord Jesus Christ, let him be Anathema Maranatha."
        },
        {
          "verse": "23",
          "text": "The grace of our Lord Jesus Christ be with you."
        },
        {
          "verse": "24",
          "text": "My love be with you all in Christ Jesus. Amen."
        }
      ]
    }
  ]
}
